import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { mbtiInfo } from "@/lib/mbti";
import { Eye, X } from "lucide-react";

/* Pré-visualização do email exatamente como sai, para o texto base e para cada perfil MBTI. */
export default function EmailPreview({ form }) {
  const [open, setOpen] = useState(false);
  const [mbti, setMbti] = useState("");
  const [leaderView, setLeaderView] = useState(false);
  const [html, setHtml] = useState("");
  const hasLeaderText = !!(form.leader_message || "").trim();
  const types = Object.keys(form.variants || {}).sort();

  useEffect(() => {
    if (!open) return;
    api.post("/communiques/preview", {
      subject: form.subject || "(sem assunto)", message: form.message || "(sem mensagem)",
      variants: form.variants, files: form.files, mbti: leaderView ? null : (mbti || null),
      leader_message: form.leader_message || null, group: leaderView ? "leaders" : null,
    }).then((r) => setHtml(r.data.html)).catch((err) => toast.error(formatApiError(err)));
  }, [open, mbti, leaderView, form.subject, form.message, form.variants, form.files, form.leader_message]);

  const tab = (value, label, color) => (
    <button key={value || "base"} onClick={() => { setLeaderView(false); setMbti(value); }} data-testid={`preview-tab-${value || "base"}`}
      className={`text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 border transition-colors ${!leaderView && mbti === value ? "bg-white text-black border-white" : "border-[#333] text-[#A3A3A3] hover:text-white"}`}
      style={!leaderView && mbti === value ? {} : { color }}>
      {label}
    </button>
  );

  return (
    <>
      <button onClick={() => { setLeaderView(false); setMbti(types[0] || ""); setOpen(true); }} disabled={!form.message.trim()}
        className="kw-btn-secondary !py-2 text-[10px] inline-flex items-center gap-1.5" data-testid="communique-preview">
        <Eye className="w-3 h-3" /> Pré-visualizar email
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="kw-card w-full max-w-3xl max-h-[92vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="preview-modal">
            <div className="flex items-center gap-3 p-4 border-b border-[#1F1F1F]">
              <Eye className="w-4 h-4 text-[#E50000]" />
              <div className="kw-overline flex-1">Pré-visualização · assunto: <span className="text-white normal-case tracking-normal">{form.subject}</span></div>
              <button onClick={() => setOpen(false)} className="text-[#737373] hover:text-white" data-testid="preview-close"><X className="w-5 h-5" /></button>
            </div>
            <div className="flex flex-wrap gap-2 p-4 pb-0">
              {types.map((t) => tab(t, `${t} · ${mbtiInfo(t)?.label || ""}`, mbtiInfo(t)?.color))}
              {tab("", types.length ? "Sem perfil (texto base)" : "Texto base")}
              {hasLeaderText && (
                <button onClick={() => setLeaderView(true)} data-testid="preview-tab-leaders"
                  className={`text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 border transition-colors ${leaderView ? "bg-white text-black border-white" : "border-[#333] text-[#EAB308] hover:text-white"}`}>
                  Liderança (Secretário/Presidente)
                </button>
              )}
            </div>
            <p className="text-[10px] text-[#737373] px-4 pt-2">"Maria" é um nome de exemplo — cada pessoa vê o seu primeiro nome.</p>
            <div className="p-4 flex-1 min-h-0">
              <iframe title="Pré-visualização do email" srcDoc={html} sandbox=""
                className="w-full h-[60vh] bg-white" data-testid="preview-frame" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
